export default "__VITE_ASSET__0JaalADE__"